import { render } from "./InstructorsTable.vue?vue&type=template&id=266a8194"
import script from "./InstructorsTable.vue?vue&type=script&lang=js"
export * from "./InstructorsTable.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/moncasan_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__